/*
  Основной долг + пени = долг к взысканию - вторая полоса итогов страницы «Как
  сформировался долг» (решение владельца 05.10.2026).

  Связывает страницу с карточкой: сумма справа - та же, что крупно стоит на
  карточке, и человек видит, что она больше сальдо из отчёта 1С на пени. Все три
  числа считает сервер; кабинет их не складывает.

  Основной долг здесь - то, что предъявляется: в режиме «только в пределах
  давности» он меньше сальдо на конец на выпавшие месяцы.
*/

import { date, money } from '../api/format.js'

export default function DebtClaim({ claim, penaltyAsOf, notice }) {
  return (
    <section className="debt-totals debt-totals--claim">
      <div className="debt-totals__item">
        <div className="summary__cap">Основной долг</div>
        <div className="debt-totals__value">{money(claim.principal)}</div>
        <div className="debt-totals__note">предъявляется к взысканию</div>
      </div>
      <div className="debt-totals__item">
        <div className="summary__cap">Пени</div>
        <div className="debt-totals__value">
          {claim.penalty === null ? 'уточняются' : `+ ${money(claim.penalty)}`}
        </div>
        <div className="debt-totals__note">
          {notice ?? `на ${date(penaltyAsOf)}, по каждому месяцу отдельно`}
        </div>
      </div>
      <div className="debt-totals__item debt-totals__item--result">
        <div className="summary__cap">Долг к взысканию</div>
        <div className="debt-totals__value">
          {claim.total === null ? 'уточняется' : money(claim.total)}
        </div>
        <div className="debt-totals__note">та же сумма, что на карточке счёта</div>
      </div>
    </section>
  )
}
